enum Brands {
    VW = 'VW',
    VIC = 'VIC',
}

export default Brands
